<template>
  <div>{{TUITranslateService.t("TUIChat.[自定义消息]")}}</div>
</template>

<script lang="ts">
import { TUITranslateService } from '../../../../@aidesk/uikit-engine';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  return {
    TUITranslateService
  };
};
export default __sfc_main;
</script>
